var blacklist = {
  INPUT: true,
  SELECT: true,
  TEXTAREA: true
};

module.exports = function(event) {
  return blacklist[event.target.tagName];
};



//////////////////
// WEBPACK FOOTER
// ./~/react-keybinding/src/is_input.js
// module id = 540
// module chunks = 0